import styled from 'styled-components';
import CommonWrapper from '../../components/ui_components/CommonComponentsStructureCss';
import QuizWidget from '../../components/Cards/QuizWidget';

const PageInner = styled.div`
  max-width: 600px;
  margin: 0 auto;
  padding: 48px 24px 80px;
`;

const PageTitle = styled.h1`
  font-size: 26px;
  font-weight: 900;
  color: #fff;
  margin: 0 0 6px;
`;

const PageSub = styled.p`
  font-size: 14px;
  color: rgba(255, 255, 255, 0.4);
  margin: 0 0 32px;
`;

const QuizPage: React.FC = () => (
  <CommonWrapper>
    <PageInner>
      <PageTitle>Quiz GWF</PageTitle>
      <PageSub>Rispondi correttamente per guadagnare crediti. Hai 15 secondi.</PageSub>
      <QuizWidget />
    </PageInner>
  </CommonWrapper>
);

export default QuizPage;
